module.exports = __webpack_public_path__ + "group.c9276d3116bef9c5516617ff342c2dd2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/group.svg
// module id = 321
// module chunks = 0